<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
    <div style="position: relative;">
      <el-tabs v-model="activeYw" @tab-click="handleYwClick" type="card" class="business-tabs">
        <el-tab-pane v-for="item in ywList" :key="item.ywcode" :label="item.ywmc" :name="item.ywcode"></el-tab-pane>
      </el-tabs>
      <div style="position: absolute; right: 0; top: 0;">
        <el-button type="primary" @click="showUploadHbzy('')" icon="el-icon-upload" size="small">资源上传</el-button>
      </div>
    </div>
    <div class="hbjb-list">
      <el-tabs tab-position="left" style="height: 580px;" @tab-click="changeTab" type="border-card">
        <el-tab-pane v-for="(item,index) in hbjbList" :id="item.id" :label="item.jbmc" :key="index">
          <draggable v-if="hbglList.length>0" v-model="hbglList" @end="setHbzyPx" chosen-class="chosen" force-fallback="true" group="people" animation="1000">
            <transition-group>
              <div class="hbgl-list" v-for="(hbzy, index1) in hbglList" :key="index1">
                <div class="img-container" style="position: relative; display: inline-block;">
                  <img :src="hbzy.fmUrl+'?access_token='+access_token" :onerror="defaultImg" alt="" style="width: 115px;height: 130px;border-radius: 16px;"/>
                  <span :class="{'status-badge': true, 'status-unpublished': hbzy.zt===0, 'status-published': hbzy.zt===1}" style="position: absolute; top: 0; left: 0;">
                    <span class="status-text">{{ hbzy.zt===0 ? '未发布' : '已发布' }}</span>
                  </span>
                </div>
                <p class="hbzy-name" :title="hbzy.hbMc">{{ hbzy.hbMc }}</p>
                <el-popover
                	placement="bottom"
                	title=""
                	width="120"
                	trigger="hover"
                	content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                	<div class="oprate-btns">
                		<p v-if="hbzy.zt==0" @click="hbzyZtEdit(hbzy.id,1)"><i class="el-icon-top"></i>发布</p>
                		<p v-if="hbzy.zt==1" @click="hbzyZtEdit(hbzy.id,0)" style="color: #f56c6c;"><i class="el-icon-bottom"></i>取消发布</p>
                		<p v-if="hbzy.zt==0" @click="showUploadHbzy(hbzy.id)"><i class="el-icon-refresh"></i>重新上传</p>
                	  <p v-if="hbzy.zt==0" @click="hbzyDel(hbzy.id)" style="color: #f56c6c;"><i class="el-icon-delete"></i>删除</p>
                	</div>
                	<i class="el-icon-more" slot="reference"></i>
                </el-popover>
              </div>
            </transition-group>
          </draggable>
          <el-empty v-else :image-size="200"></el-empty>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
        title="资源上传"
        :visible.sync="uploadHbzyDialog"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false">
      <div>
        <el-upload
            ref="upload"
            name="file"
            action="api/admin/HbglController/hbzyUpload"
            :data="{ 'access_token': access_token, 'id' : hbzyId, 'ywcode': activeYw}"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            accept=".zip">
          <el-button type="text">上传附件</el-button>
        </el-upload>
      </div>
    </el-dialog>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
export default {
	name: 'hbzyglList',
	data() {
		return {
      access_token: sessionStorage.getItem("access_token"),
			userType: sessionStorage.getItem("userType"),
			loading: false,
      hbjbList: [],//绘本资源级别列表
      hbjbId: '',//绘本资源级别id
      hbglList: [],//绘本资源列表
      uploadHbzyDialog: false,//资源上传弹窗
      hbzyId: '',//绘本资源id
      defaultImg: 'this.src="' + require("../../assets/img/02tibu.png") + '"',
      ywList: [],
      activeYw: ''
		}
	},
  watch: {
    hbglList(value) {
      console.log(value);
    }
  },
  components:{draggable},
	created() {
    // 获取业务列表
    this.findYwList();
	},
	methods: {
    // 获取业务列表
    findYwList(){
        this.$post("admin/YwController/list", {zt: '1'}).then(rep =>{
            if(rep.code == '1'){
                this.ywList = rep.result.list;
                if(this.ywList.length > 0){
                    this.activeYw = this.ywList[0].ywcode;
                    this.findHbjbList();
                }
            }
        })
    },
    handleYwClick(tab, event) {
        this.findHbjbList();
    },
    //获取绘本资源级别
    findHbjbList() {
			var _this = this;
      _this.$post("user/HbglController/hbjbList", {ywcode: _this.activeYw}).then(rep => {
        if (rep.code == '1') {
          _this.hbjbList = rep.result.list;
          if(_this.hbjbList.length > 0){
            _this.hbjbId = _this.hbjbList[0].id;
            _this.findHbglList();
          } else {
             _this.hbglList = [];
          }
        }
      })
		},
    changeTab(tab, event) {
      this.hbjbId = tab.$attrs.id;
      this.findHbglList();
    },
		// 获取绘本资源数据
		findHbglList() {
			var _this = this;
			var params = {
        jbId: _this.hbjbId,
        ywcode: _this.activeYw
      }
			_this.loading = true;
			_this.$post("admin/HbglController/hbzyList", params).then(rep => {
				_this.loading = false;
				if (rep.code == '1') {
					_this.hbglList = rep.result.list;
				} else {
					_this.$message({
						type: "error",
						message: rep.msg
					});
				}
			})
		},
    showUploadHbzy(id){
      this.uploadHbzyDialog = true;
      if(id != null && id != '' && id!= undefined){
        this.hbzyId = id;
      }else{
        this.hbzyId = '';
      }
    },
    handleClose(done) {
      this.uploadHbzyDialog = false;
      this.$refs.upload.clearFiles() // 清空已上传文件列表
      this.findHbglList();
    },
    handleSuccess(res){
      if (res.code == '1') {
        this.$message({
          type: "success",
          message: '上传成功'
        });
        this.uploadHbzyDialog = false;
        this.hbzyId = '';
        this.$refs.upload.clearFiles() // 清空已上传文件列表
        this.findHbglList();
      }else{
        this.$refs.upload.clearFiles() // 清空已上传文件列表
        this.$message({
          type: "error",
          message: res.msg
        });
      }
    },
    beforeUpload(file){
      const isZip = file.type === 'application/x-zip-compressed';
      if (!isZip) {
        this.$message.error('请上传zip文件');
        return false;
      }
    },
		// 删除
    hbzyDel(id) {
			this.$confirm('是否确认删除', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post("admin/HbglController/hbzyDel", { id: id }).then(rep => {
					if (rep.code == '1') {
						this.$message({
							type: "success",
							message: '删除成功'
						});
						this.findHbglList();
					} else {
						this.$message({
							type: "error",
							message: rep.msg
						});
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			})
		},
    hbzyZtEdit(id, zt) {
      var _this = this;
      var title = zt == 1 ? '发布' : '取消发布';
      this.$confirm('是否确认'+ title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {
          id: id,
          zt: zt,
        }
        _this.$post("admin/HbglController/hbzyZtEdit", params).then(rep => {
          if (rep.code == '1') {
            _this.$message({
              type: "success",
              message: '操作成功'
            });
            _this.findHbglList();
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      })
    },
    //设置排序
    setHbzyPx(){
      var _this = this;
      var ids = [];
      for (var i = 0; i < _this.hbglList.length; i++) {
        ids.push(_this.hbglList[i].id);
      }
      _this.loading = true;
      _this.$post("admin/HbglController/hbzyPx", ids, 'json').then(rep => {
        _this.loading = false;
        if (rep.code == '1') {

        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    }
	},
}
</script>

<style lang="less">
.school-manage {
  .el-tabs__content{
    height: 100%;
    overflow: auto;
  }
  .business-tabs {
    .el-tabs__header {
      margin: 0;
      border-bottom: 1px solid #E4E7ED;
    }
    .el-tabs__content {
      display: none;
    }
  }
  .hbgl-list {
    width: 130px;
    height: 190px;
    padding: 6px;
    display: inline-block;
    background-color: #fdfdfd;
    border: solid 1px #eee;
    border-radius: 6px;
    margin: 0 10px 10px 10px;
    cursor: move;
		box-shadow: 0 2px 4px 0 rgba(0,0,0,.1);
		.hbzy-name{
			width: 100%;
			height: 20px;
			text-align: center;
			font-size: 14px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			color: #303133;
			//margin-top: 6px;
		}
		.el-popover__reference-wrapper{
			float: right;
			line-height: 18px;
			color: #7f7f7f;
			cursor: pointer;
		}
  }

  .exportItem:hover {
    background-color: #f1f1f1;
    cursor: move;
  }

  .chosen {
    border: solid 2px #3089dc !important;
  }

  .el-tabs--border-card>.el-tabs__header {
    background-color: #C3DEFF;
    border-bottom: 1px solid #E4E7ED;
    margin: 0;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item {
    color: #5e6062;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: #409EFF;
  }
}
.el-popover{
	min-width: 120px;
	.oprate-btns{
		p{
			margin-bottom: 7px;
			cursor: pointer;
			padding: 3px 12px;
			i{margin-right: 5px}
		}
		p:last-child{
			margin-bottom: 0;
		}
		p:hover{
			background: #f1f1f1;
		}
	}
}
.el-popover--plain{
	padding: 7px 0;
}
.status-badge {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 0;
}
.status-badge::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  clip-path: polygon(0 50%, 50% 0, 100% 0%, 0 100%);
}
.status-unpublished::before {
  border-width: 50px 50px 0 0;
  border-color: #f85151 transparent transparent transparent;
}
.status-published::before {
  border-width: 50px 50px 0 0;
  border-color: #4CAF50 transparent transparent transparent;
}
.status-text {
  position: absolute;
  width: 38px;
  top: 10px;
  left: 0px;
  color: white;
  font-size: 12px;
  transform: rotate(-45deg);
}
.img-container {
  margin-bottom: 8px;
}
</style>